import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface RiskDisclaimerProps {
  score: number;
  rating: string;
  breakdown: {
    momentum: number;
    position: number;
    technical: number;
    fundamentals: number;
    sentiment: number;
    risk: number;
  };
}

export const RiskDisclaimer = ({ score, rating, breakdown }: RiskDisclaimerProps) => {
  return (
    <Alert variant="destructive" className="border-2 border-destructive/50 bg-destructive/10">
      <AlertTriangle className="h-5 w-5" />
      <AlertTitle className="text-lg font-bold mb-2">⚠️ HIGH-RISK INVESTMENT WARNING</AlertTitle>
      <AlertDescription className="space-y-3 text-sm">
        <div className="font-semibold">
          Low market cap cryptocurrencies ($10M-$500M) carry EXTREME risk:
        </div>
        <ul className="list-disc pl-5 space-y-1">
          <li>High volatility (50%+ swings possible)</li>
          <li>Lower liquidity (harder to exit positions)</li>
          <li>Higher chance of project failure</li>
          <li>Not suitable for conservative investors</li>
        </ul>
        
        <div className="border-t border-destructive/30 pt-3 mt-3">
          <p className="font-semibold mb-2">
            This scoring system identifies potential opportunities based on current data metrics only. 
            It is NOT financial advice and does NOT guarantee future performance.
          </p>
          
          <div className="bg-background/50 p-3 rounded-md mt-2 font-mono text-xs">
            <div className="mb-1">
              <span className="font-bold">Score: {score.toFixed(1)}/100</span> | <span className="font-bold">Rating: {rating}</span>
            </div>
            <div className="text-muted-foreground">
              Breakdown: Momentum [{breakdown.momentum.toFixed(1)}] | Position [{breakdown.position.toFixed(1)}] | Technical [{breakdown.technical.toFixed(1)}] | 
              Fundamentals [{breakdown.fundamentals.toFixed(1)}] | Sentiment [{breakdown.sentiment.toFixed(1)}] | Risk [{breakdown.risk.toFixed(1)}]
            </div>
          </div>
        </div>

        <div className="text-xs italic mt-3 pt-3 border-t border-destructive/30">
          Always conduct your own research (DYOR) and never invest more than you can afford to lose. 
          Consider consulting with a licensed financial advisor before making investment decisions.
        </div>
      </AlertDescription>
    </Alert>
  );
};
